const PLACEHOLDER = '<path>';

// The Outbox only receives PDFs from the virtual printer, so anything between a path separator and
// ".pdf" is a path whose file name may be a patient name (apostrophes and spaces included).
const PDF_PATH = /(?:[A-Za-z]:)?[\\/].*?\.pdf/gi;

export function scrubFilePaths(text: string): string {
  return text.replace(PDF_PATH, PLACEHOLDER);
}

export function getErrorCode(err: unknown): string {
  const message = err instanceof Error ? err.message : String(err);
  return /\b(E[A-Z]{3,})\b/.exec(message)?.[1] ?? 'UNKNOWN';
}
